import { render, staticRenderFns } from "./DiscussionSubpage.vue?vue&type=template&id=42ff4de4&"
import script from "./DiscussionSubpage.vue?vue&type=script&lang=js&"
export * from "./DiscussionSubpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports